module.exports = __webpack_public_path__ + "assets/img/fdebfe75f3984b947602bf8f30b0a658.png";